// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"0b3a37b4ca98e967","2937":"e7601066ca3501ac","5607":"b816e3cb37dc4e29","9814":"bf42485c5ec9f70f"}[chunkId] + ".js";
};